import { IconSVG } from '../types';

export const MessageSquare = ({ size, style }: IconSVG) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={style}
    fill="none"
    viewBox="0 0 24 24"
    >
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        fill="none"
        d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
      />
    </svg>
  );
};